/* Product page bars, on every product page (snippets/cq-product-bar.liquid). One product bar at the bottom at every
   width (photo, name, chosen options, price, Add to cart), shown only once the buy box's Add to cart has scrolled up
   under the site header and hidden while the footer is in view; the theme's own phone bar (sticky-cart) steps aside.
   Phones and tablets add a Sections button that opens a sheet of the info sections, a modal dialog (focus stays in it,
   Escape closes it, focus returns to the button). The site header itself stays as on every page. A product with
   a story (assets/cq-product-marketing.js) starts the bars itself, adding Overview and its desktop info index;
   every other product starts them here. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var started = false;
  var LINES = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M4 6h2M4 12h2M4 18h2M9 6h11M9 12h11M9 18h11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  function hdrH() { var h = document.querySelector('header#header'); return h ? h.offsetHeight : 72; }
  function headerBottom() {
    var header = document.querySelector('sticky-header, .header-wrapper, header');
    if (!header) return 0;
    return Math.max(0, Math.min(header.getBoundingClientRect().bottom, 140));
  }
  function norm(v) { return String(v || '').replace(/[“”″]/g, '"').trim(); }
  function shown(el) { return !!(el && el.getClientRects().length); }

  /* A scroll with an ease and a set duration (native smooth scrolling has no duration). The shopper's own wheel, touch
     or key ends it at once. A long trip (more than a screen and a half) moves most of the way at once and glides only
     the last half screen, so the page never whips past its content. */
  function glide(to, ms, done) {
    var from = window.scrollY, d = to - from, stop = false, t0 = null;
    var near = window.innerHeight * .55;
    if (!reduce.matches && ms && Math.abs(d) > window.innerHeight * 1.5) {
      from = to - (d > 0 ? near : -near);
      window.scrollTo({ top: from, behavior: 'instant' });
      d = to - from; ms = 520;
    }
    var ease = ms > 400 && Math.abs(d) > window.innerHeight * .6 ? function (p) { return p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; } : function (p) { return 1 - Math.pow(1 - p, 4); };
    /* The site sets scroll-behavior: smooth on html, so every step here asks for an instant position. */
    if (reduce.matches || !ms || Math.abs(d) < 2) { if (Math.abs(d) >= 2) window.scrollTo({ top: to, behavior: 'instant' }); if (done) done(); return; }
    var evs = ['wheel', 'touchstart', 'keydown'];
    var cancel = function () { stop = true; };
    evs.forEach(function (ev) { window.addEventListener(ev, cancel, { capture: true, passive: true }); });
    function end() { evs.forEach(function (ev) { window.removeEventListener(ev, cancel, true); }); if (done) done(stop); }
    function step(t) {
      if (stop) { end(); return; }
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / ms);
      window.scrollTo({ top: from + d * ease(p), behavior: 'instant' });
      if (p < 1) requestAnimationFrame(step); else end();
    }
    requestAnimationFrame(step);
  }

  /* The bottom bar (rendered hidden and inert by the snippet). It mirrors the buy box: the chosen options, the price
     (with "Subscribe & save" beside a subscription price), the chosen photo, and an Add to cart that presses the buy
     box's own button, so the cart, the selling plan and the add-ons always come from the buy box. */
  function buyBar(bar, root) {
    var purchase = root.querySelector('cq-purchase-options');
    var source = function () {
      return (purchase && (purchase.querySelector('.cq-purchase-add.bold_clone') || purchase.querySelector('.cq-purchase-add'))) ||
        root.querySelector('form[action*="/cart/add"] [type="submit"][name="add"], form[action*="/cart/add"] button[type="submit"]');
    };
    if (!source()) return null;
    /* The theme's own phone bar steps aside (its listeners stop, so it no longer lifts the chat button either). */
    function quietTheme() {
      document.querySelectorAll('sticky-cart').forEach(function (sc) {
        sc.classList.add('cqs-off');
        if (sc.purchaseEvents) sc.purchaseEvents.abort();
        ['purchaseObserver', 'purchaseOverlayObserver', 'purchaseResizeObserver'].forEach(function (k) { if (sc[k]) sc[k].disconnect(); });
        sc.classList.remove('is-visible');
      });
    }
    quietTheme();
    window.addEventListener('load', quietTheme, { once: true });
    document.body.appendChild(bar);
    var img = bar.querySelector('.cqs-bb-img img'), opts = bar.querySelector('.cqs-bb-opts');
    var priceEl = bar.querySelector('.cqs-bb-price'), add = bar.querySelector('.cqs-bb-add');

    function thumb() {
      var t = document.querySelector('.cq-sticky-thumb img') || root.querySelector('.product-media-main.is-active img') || root.querySelector('.product-media-main img');
      var src = t && (t.currentSrc || t.getAttribute('src'));
      if (!src) return;
      try { var u = new URL(src, location.href); u.searchParams.set('width', '160'); src = u.href; } catch (e) {}
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    }
    function sync() {
      var picked = Array.prototype.filter.call(root.querySelectorAll('form[action*="/cart/add"] input[type="radio"]:checked, cq-purchase-options input[type="radio"]:checked'), function (i) { return /-option-/.test(i.name); })
        .map(function (i) { return norm(i.value); });
      opts.textContent = picked.filter(function (v, k, a) { return a.indexOf(v) === k; }).join(' / ');
      var total = purchase && purchase.purchaseTotal;
      var price = total ? total.totalText : (root.querySelector('.price-item--regular, .price .money') || {}).textContent;
      priceEl.textContent = (price || '').trim();
      /* A Subscribe & save choice says so next to its price, so the bar never shows a subscription price as a plain one.
         The choice is a radio pair or a single switch (a checkbox, unchecked = one-time); both carry value "subscribe". */
      if (purchase && purchase.querySelector('input[value="subscribe"]:checked')) {
        var sub = document.createElement('small');
        sub.className = 'cqs-bb-sub';
        sub.textContent = bar.dataset.sub || 'Subscribe & save';
        priceEl.appendChild(sub);
      }
      var src = source();
      var busy = src && (src.disabled || src.classList.contains('loading') || src.getAttribute('aria-disabled') === 'true');
      add.disabled = !!(total && total.available === false) || !!busy;
      thumb();
    }
    add.addEventListener('click', function () {
      if (purchase && purchase.resync) purchase.resync();
      var src = source();
      if (src && !src.disabled) src.click();
      else if (src) src.scrollIntoView({ block: 'center', behavior: reduce.matches ? 'auto' : 'smooth' });
    });
    if (purchase) {
      purchase.addEventListener('cq:purchase-total', sync);
      purchase.addEventListener('cq:variant-change', function () { setTimeout(sync, 60); });
    }
    root.addEventListener('change', function () { setTimeout(sync, 60); });

    var shownNow = false;
    function show(on) {
      if (document.querySelector('dialog[open]:not(.cqpm-sheet)')) on = false;
      if (on === shownNow) return;
      shownNow = on;
      /* INP: the one read comes before the writes (the bar slides, it does not change height), so showing the bar
         does not lay the page out twice. */
      var height = on ? bar.offsetHeight : 0;
      bar.classList.toggle('is-shown', on);
      bar.inert = !on;
      document.documentElement.classList.toggle('cqs-bb-on', on);
      if (on) { sync(); document.body.style.setProperty('--cq-buybar-height', height + 'px'); }
      else document.body.style.removeProperty('--cq-buybar-height');
      document.body.classList.toggle('cq-buybar-on', on);
    }
    sync();
    return { bar: bar, show: show, sync: sync, source: source };
  }

  /* Start the bars once. opts (from the story script, all optional): root, lp (its desktop info index), overview (the
     Overview label) and overviewEl (a function returning the story's first section). Returns the scroll helpers the
     story uses (goInfo, goInfoBy, goOverview, scrollToEl, queue), or null when the page has no bar. */
  function start(opts) {
    var el = document.querySelector('[data-cq-pbar]');
    if (started || !el) return null;
    started = true;
    opts = opts || {};
    var root = opts.root || el.closest('.product-info-wrap') || document;
    var lp = opts.lp || null;
    var bb = buyBar(el, root);
    var info = window.matchMedia('(min-width: 990px)');
    var html = document.documentElement;
    var footer = document.querySelector('footer.footer') || document.querySelector('footer');
    var tabLinks = Array.prototype.slice.call(root.querySelectorAll('.pdp-tab-part .tablinks'));
    var toggles = Array.prototype.slice.call(root.querySelectorAll('.product-info-description-mobile .facet-toggle'));
    var infoItems = tabLinks.map(function (l, i) {
      var label = l.textContent.trim();
      return { label: label, link: l, toggle: toggles.filter(function (t) { return t.textContent.trim() === label; })[0] || toggles[i] };
    });

    /* Scrolling to a section: one eased glide per click (duration grows with the distance, 450 to 900 ms), settled once
       at the end if something above moved, never corrected after the shopper's own wheel, touch or key. */
    var settle = null;
    function offset() { return hdrH() + 16; }
    function topOf(target) { return target.getBoundingClientRect().top + window.scrollY - offset(); }
    function scrollToY(dest, after) {
      settle = null;
      if (Math.abs(window.scrollY - dest) <= 2) return;
      var ms = Math.round(Math.min(900, Math.max(450, 300 + Math.abs(dest - window.scrollY) * .12)));
      var id = settle = {};
      glide(dest, ms, function (stopped) {
        if (settle !== id) return;
        settle = null;
        if (!stopped && after) after();
      });
    }
    function scrollToEl(target) {
      scrollToY(topOf(target), function () {
        if (Math.abs(target.getBoundingClientRect().top - offset()) > 6) window.scrollTo({ top: topOf(target), behavior: 'instant' });
      });
    }
    /* Focus without scrolling; returns the target (the sheet focuses it again once the dialog has closed). */
    function focusQuiet(target) {
      if (!target || !target.focus) return null;
      if (!target.hasAttribute('tabindex') && !/^(BUTTON|A)$/.test(target.tagName)) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      return target;
    }
    function goInfo(k) {
      var it = infoItems[k];
      if (!it) return null;
      if (info.matches && lp) {
        /* Story pages, desktop: when the info area is already in view, the index's own anchor and crossfade do the work
           (one movement, not two). Otherwise the section switches at once, out of sight, and one glide brings it up. */
        var pr = lp.part.getBoundingClientRect();
        var inView = pr.top < window.innerHeight * .5 && pr.bottom > offset() + 120;
        if (it.link.getAttribute('aria-selected') !== 'true') {
          if (inView) it.link.click();
          else { it.link.dataset.cqsPass = '1'; it.link.click(); delete it.link.dataset.cqsPass; }
        }
        if (!inView) scrollToY(lp.rowTop ? lp.rowTop() : topOf(lp.part));
        return focusQuiet(it.link);
      }
      if (shown(it.toggle)) {
        if (it.toggle.getAttribute('aria-expanded') !== 'true') it.toggle.click();
        scrollToEl(it.toggle);
        return focusQuiet(it.toggle);
      }
      if (shown(it.link)) {
        if (it.link.getAttribute('aria-selected') !== 'true') it.link.click();
        scrollToEl(it.link.closest('.pdp-tab-part') || it.link);
        return focusQuiet(it.link);
      }
      return null;
    }
    function goInfoBy(re) {
      for (var k = 0; k < infoItems.length; k++) { if (re.test(infoItems[k].label)) { goInfo(k); return true; } }
      return false;
    }
    function goOverview() {
      var first = opts.overviewEl && opts.overviewEl();
      if (!first) return null;
      scrollToEl(first);
      return focusQuiet(first.querySelector('h2, h3') || first);
    }

    /* Phones and tablets: the Sections sheet from the bottom bar, a native modal dialog. Story pages list Overview
       first; every page lists its info sections. No sections, no button. */
    var slot = bb && bb.bar.querySelector('[data-cqs-bb-slot]');
    var rows = (opts.overviewEl ? 1 : 0) + infoItems.length;
    var sheet = null, opener = null;
    if (slot && rows) {
      var jump = el.dataset.jump || 'Sections';
      sheet = document.createElement('dialog');
      sheet.className = 'cqpm-sheet';
      sheet.setAttribute('aria-label', jump);
      var panel = document.createElement('div');
      panel.className = 'cqpm-sheet-panel';
      panel.innerHTML = '<div class="cqpm-sheet-head"><p></p><button type="button" class="cqpm-sheet-x" data-cqpm-sheet-close></button></div><ul role="list"></ul>';
      panel.querySelector('p').textContent = jump;
      panel.querySelector('.cqpm-sheet-x').textContent = el.dataset.jumpClose || 'Close';
      var list = panel.querySelector('ul');
      function row(text, attr, value) {
        var li = document.createElement('li'), b = document.createElement('button');
        b.type = 'button';
        b.setAttribute(attr, value);
        b.textContent = text;
        li.appendChild(b);
        list.appendChild(li);
      }
      if (opts.overviewEl) row(opts.overview || 'Overview', 'data-overview', '');
      infoItems.forEach(function (it, k) { row(it.label, 'data-k', String(k)); });
      var scrim = document.createElement('div');
      scrim.className = 'cqpm-sheet-scrim';
      scrim.setAttribute('data-cqpm-sheet-close', '');
      sheet.appendChild(scrim);
      sheet.appendChild(panel);
      document.body.appendChild(sheet);
      opener = document.createElement('button');
      opener.type = 'button';
      opener.className = 'cqpm-jump cqs-bb-icon';
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-expanded', 'false');
      opener.setAttribute('aria-label', jump);
      opener.innerHTML = LINES + '<span class="cqpm-jump-text"></span>';
      opener.querySelector('.cqpm-jump-text').textContent = jump;
      slot.appendChild(opener);
    } else if (bb) bb.bar.classList.add('cqs-bb--solo');

    var closing = 0;
    function openSheet() {
      clearTimeout(closing);
      if (!sheet.open) sheet.showModal();
      html.classList.add('cqs-sheet-open');
      requestAnimationFrame(function () { sheet.classList.add('is-open'); });
      opener.setAttribute('aria-expanded', 'true');
      var first = sheet.querySelector('button[data-overview], button[data-k]');
      if (first) first.focus({ preventScroll: true });
    }
    /* Closing slides the panel down first, then closes the dialog. Focus then goes to the chosen section (to), or back
       to the Sections button. */
    function closeSheet(to) {
      sheet.classList.remove('is-open');
      html.classList.remove('cqs-sheet-open');
      opener.setAttribute('aria-expanded', 'false');
      clearTimeout(closing);
      closing = setTimeout(function () { if (sheet.open) sheet.close(); (to || opener).focus({ preventScroll: true }); }, reduce.matches ? 0 : 220);
    }
    if (sheet) {
      opener.addEventListener('click', function () { if (sheet.open && sheet.classList.contains('is-open')) closeSheet(); else openSheet(); });
      /* Escape: the dialog's cancel; the panel still slides away before it closes. */
      sheet.addEventListener('cancel', function (e) { e.preventDefault(); closeSheet(); });
      /* Closed some other way (the browser closed it at once): the page state follows. */
      sheet.addEventListener('close', function () {
        if (!sheet.classList.contains('is-open')) return;
        sheet.classList.remove('is-open');
        html.classList.remove('cqs-sheet-open');
        opener.setAttribute('aria-expanded', 'false');
      });
      /* A section choice starts its glide at once while the panel slides away (the page behind is inert until the
         dialog closes, so its focus lands after). */
      sheet.addEventListener('click', function (e) {
        if (e.target.closest('[data-cqpm-sheet-close]')) { closeSheet(); return; }
        var k = e.target.closest('[data-k]'), ov = e.target.closest('[data-overview]');
        if (ov) closeSheet(goOverview());
        else if (k) closeSheet(goInfo(+k.dataset.k));
      });
    }

    var ticking = false, bbOn = false;
    function update() {
      ticking = false;
      /* The buy box's button as it is now: the subscription app can swap in its own copy after load. */
      var main = bb && bb.source();
      var mr = main ? main.getBoundingClientRect() : null;
      var foot = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var dialog = !!document.querySelector('dialog[open]:not(.cqpm-sheet)');
      var cover = headerBottom();
      /* A 16 px margin either way, so the bar does not flicker while the main button sits on the edge. */
      var m = bbOn ? -16 : 16;
      var buyOff = mr ? (mr.bottom < cover - m || (!mr.width && !mr.height)) : false;
      /* The chat bubble steps aside while the main button passes under its corner. */
      html.classList.toggle('cqs-chat-dodge', !!(mr && !buyOff && mr.bottom > window.innerHeight - 112 && mr.top < window.innerHeight && mr.right > window.innerWidth - 124));
      bbOn = buyOff && !dialog && !foot;
      if (bb) bb.show(bbOn);
    }
    /* INP: update() reads geometry after the next paint (a frame callback runs before the browser lays the frame out,
       so a read there lays the whole page out again whenever a tap changed any markup; 200 to 400 ms on a slow phone
       with this page's element count). The bar's state follows one frame later, which no shopper can see. */
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(function () { setTimeout(update, 0); }); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    /* The footer's first pixel hides the bar even between scroll events (momentum scrolling). */
    if (footer && 'IntersectionObserver' in window) new IntersectionObserver(queue).observe(footer);
    html.classList.add('cq-pbar');
    queue();
    return { goInfo: goInfo, goInfoBy: goInfoBy, goOverview: goOverview, scrollToEl: scrollToEl, queue: queue };
  }

  window.cqProductBar = { start: start };
  /* A story page has started the bars by now (its script runs before this event); every other product starts here. */
  document.addEventListener('DOMContentLoaded', function () { start(); });
})();
